import { getAuthAxiosBackend } from "../helpers/axios"

class LinkServices{

    constructor(){
    }

    get(id){
        return getAuthAxiosBackend().get( 'links' + '/' + id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('links', {params: data})
    }

    add(link){
        return getAuthAxiosBackend().post('links', link)
    }

    edit(id, link){
        link.append('_method', 'put')
        return getAuthAxiosBackend().post('links' + '/' + id, link)
    }

    delete(id){
        return getAuthAxiosBackend().delete('links' + '/' + id)
    }
}

export default new LinkServices()